import { FileType } from './file-type';

export interface IFile {
    type: FileType,
    file: File
}